import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { Patient } from "../../models/patient.model";
import * as _ from "underscore";
import * as moment from "moment";
import { PatientService } from "../../services/patient.service";
import { LowyGridComponent } from "../../components/grid/grid.component";

@Component({
  templateUrl: "./patient-listing.component.html",
  styleUrls: ["patient-listing.component.scss"],
  providers: [PatientService],
})
export class PatientListingComponent implements OnInit {
  @ViewChild("grid") grid: LowyGridComponent;

  public patientIds: Patient[];

  constructor(private router: Router, private patientService: PatientService) {}

  async ngOnInit() {
    this.patientIds = await this.patientService.getPatientIds();
    this.grid.dataReady(
      this.patientIds,
      ["checkbox", "dataType", "patientId", "patId2", "patId3", "patId4"],
      ["checkbox", "dataType", "Patient ID", "A Number", "Site ID", "ID 4"]
    );
  }

  public async downloadAllRecords(downloadType: string) {
    this.grid.downloadFiles(downloadType, this.patientIds);
  }
}



// WEBPACK FOOTER //
// ./src/app/home/patient-listing/patient-listing.component.ts